/*
 * @Descripttion:
 * @Author: zhangtingjiang
 * @Date: 2019-12-10 11:57:23
 */
export default {
  path: '/',
  name: 'paidServiceManage',
  component: () => import('@/views/Application'),
  hidden: false,
  meta: {
    role: ['admin']
  },
  children: [
    {
      path: '/paidService',
      name: 'paidService',
      hidden: false,
      component: () => import('@/views/paid-service'),
      meta: {
        title: '收费服务',
        icon: 'fa fa-dashboard iconTitle',
        iconClass: 'icon-pidservice',
        role: ['admin']
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/modules/router-paidservice.js